import { searchEventsPaths } from '#/modules/search/events/routing/searchEvents.paths';
import { searchInternshipsPaths } from '#/modules/search/internships/routing/searchInternships.paths';
import { searchJobsPaths } from '#/modules/search/jobs/routing/searchJobs.paths';
import { searchOrgsPaths } from '#/modules/search/orgs/routing/searchOrgs.paths';
import type { SearchType } from '#/modules/search/types/SearchType';
import { searchVolopsPaths } from '#/modules/search/volops/routing/seachVolops.paths';

export function getListingTypeFromPathname(pathname: string): SearchType {
  if (searchJobsPaths.includes(pathname)) {
    return 'JOB';
  }

  if (searchInternshipsPaths.includes(pathname)) {
    return 'INTERNSHIP';
  }

  if (searchVolopsPaths.includes(pathname)) {
    return 'VOLOP';
  }

  if (searchEventsPaths.includes(pathname)) {
    return 'EVENT';
  }

  if (searchOrgsPaths.includes(pathname)) {
    return 'ORG';
  }

  return 'JOB';
}
